




document.addEventListener("DOMContentLoaded", function () {
    const cartDrawerSettings = {
        physical: "/products/cruise-map",
        physicalRiver: "/products/custom-river-cruise-map",
        digital: "/products/cruise-map-digital",
        digitalRiver: "/products/digital-custom-river-cruise-map",
        bundle: "/products/custom-cruise-album-map",
        shopAll: "/collections/frontpage",
        firstMpText: "Add another map to get 15% off",
        firstMpImg: "//thecruisemaps.com/cdn/shop/files/Rectangle_158_90x90.png?v=1787268134",
        secondAlbText: "Add another Album Size map to get 50% off The Cruise Album",
        secondAlbImg: "//thecruisemaps.com/cdn/shop/files/Rectangle_184_90x90.png?v=1787268140",
        thirdAlbText: "Add 2 more Album Size maps to get The Cruise Album for free!",
        thirdAlbImg: "//thecruisemaps.com/cdn/shop/files/Rectangle_185_90x90.png?v=1787268145",
        fourthAlbText: "Add 1 more Album Size map to get The Cruise Album for free!",
        fourthAlbImg: "//thecruisemaps.com/cdn/shop/files/Rectangle_186_90x90.png?v=1787268145",
        elseMpText: "Add another map",
        elseMpImg: "//thecruisemaps.com/cdn/shop/files/Rectangle_158_90x90.png?v=1787268134",
        notMpText: "Explore our range of 100% accurate Custom Cruise Maps",
        notMpImg: "//thecruisemaps.com/cdn/shop/files/Rectangle_188_90x90.png?v=1787268146"
    };


    function initReviewsAndTrusted() {
        const cartBody = document.querySelector(".upcart-cart-body");
        let reviewsDiv = document.createElement("div");
        reviewsDiv.innerHTML = `<style>
            .reviews-section {
                max-width: 500px;
                font-family: 'Termina', 'Sofia Pro', sans-serif !important;
                padding: 0px 20px;
            }
            .reviews-title {
                font-size: 15px;
                color: #333;
                font-weight: 500;
                margin-top: 5px;
            }
            .reviews-subtitle {
                font-size: 12px;
                color: #777;
                margin-bottom: 10px;
            }
            .reviews-slider {
                overflow: hidden;
                width: 100%;
                position: relative; /* Ensure arrows are inside */
            }
            .reviews-container {
                display: flex;
                transition: transform 0.5s ease-in-out;
            }
            .review-card {
                flex: 0 0 100%;
                display: flex;
                align-items: flex-start;
                gap: 15px;
                background: white;
                box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
                text-align: left;
                min-width: 100%;
                box-sizing: border-box;
            }
            .avatar-container {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .avatar {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background-color: #203c51;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                color: white;
                font-size: 16px;
                text-transform: uppercase;
            }
            .review-content-wrapper {
                flex: 1;
                text-align: left;
                max-width: 100%;
                display: flex;
                flex-direction: column;
            }
            .review-header {
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 15px;
                font-weight: 300;
                color: #333;
                margin-left: 55px;
            }
            .star-rating {
                display: flex;
                gap: 2px;
                font-size: 14px;
                color: #f5b301;
            }
            .review-text {
                color: #444;
                font-size: 14px;
                line-height: 1.6;
                padding-left: 55px;
                padding-right: 46px;
                margin-top: 4px;
                word-wrap: break-word;
                overflow-wrap: break-word;
                max-width: 100%;
                display: block;
                flex-grow: 1;
            }
            .review-arrows {
                position: absolute;
                top: 30%;
                left: 1;
                width: 100%;
                display: flex;
                justify-content: space-between;
                transform: translateY(-50%);
                z-index: 10;
                pointer-events: none;
            }
            .review-arrow {
                border: none;
                color: white;
                font-size: 16px;
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                cursor: pointer;
                transition: background 0.3s ease;
                pointer-events: all;
            }
            .review-prev {
                position: absolute;
            }
            .review-next {
                position: absolute;
                right: 10px;
            }
            .review-arrow:hover {
                background: rgba(0, 0, 0, 0.6);
            }


            /* Trusted By Section */
            .trusted-by-section {
                font-family: 'Termina', 'Sofia Pro', sans-serif !important;
                text-align: left;
                overflow: hidden;
                margin-top: 15px;
                padding: 0px 20px;
            }
            .trusted-by-section p {
                font-size: 15px;
                color: #333333;
                letter-spacing: 0.08em;
                font-weight: 500;
                margin-bottom: 16px;
            }
            .logos-container {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                overflow: hidden;
                padding: 10px 0;
            }
            .logos-slide {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 20px;
                animation: slide 30s linear infinite;
                width: max-content;
            }
            @keyframes slide {
                0% { transform: translateX(0); }
                100% { transform: translateX(-33%); }
            }
            .logos-slide img {
                max-height: 45px;
                width: auto;
                max-width: 90px;
                opacity: 0.7;
                transition: all 0.3s ease;
                filter: grayscale(1);
                object-fit: contain;
            }
            .logos-slide img.m-light {
                opacity: 0.5;
                max-width: 70px;
            }
            .logos-slide img.m-light:hover,
            .logos-slide img:hover {
                opacity: 1;
                filter: grayscale(0);
                transform: scale(1.05);
            }
        </style>

        <div class="reviews-section">
            <div class="reviews-title"><p>Customer Reviews</p></div>
            <div class="reviews-subtitle">Trusted by 30,000+ cruisers worldwide</div>
            <div class="reviews-slider">
                <div class="reviews-container">
                    <div class="review-card">
                        <div class="review-content-wrapper">
                            <div class="review-header">Carolyn M. <div class="star-rating">★★★★★</div></div>
                            <div class="review-text">The map was accurate to the route taken and even showed the miles travelled.</div>
                        </div>
                    </div>
                    <div class="review-card">
                        <div class="review-content-wrapper">
                            <div class="review-header">Vicki <div class="star-rating">★★★★★</div></div>
                            <div class="review-text">Very happy with the quality of the map including the framing. Map arrived quickly and safely too.🙂</div>
                        </div>
                    </div>
                    <div class="review-card">
                        <div class="review-content-wrapper">
                            <div class="review-header">L.G <div class="star-rating">★★★★★</div></div>
                            <div class="review-text">Second to none customer service, fast delivery and faultless product. What more could you want?!</div>
                        </div>
                    </div>
                </div>
                <!-- Arrows placed INSIDE the reviews-slider -->
                <div class="review-arrows">
                    <button class="review-arrow review-prev">&#10094;</button>
                    <button class="review-arrow review-next">&#10095;</button>
                </div>
            </div>
        </div>
        <!-- Trusted By Section -->
        <div class="trusted-by-section">
            <p>In partnership with</p>
            <div class="logos-container">
                <div class="logos-slide">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/4_ceb086cf-faf4-4b37-bbae-5bbc7c19bf8a.png?v=1740592715" alt="HX">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/2_f0c9738d-0c37-4f63-aebf-2325a97271d2.png?v=1740592715" alt="Hurtigruten expeditions">
                    <img class="m-light" src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/msc-logo.png?v=1758704905" alt="MSC">
                    <img style='max-width: 80px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/logo-hurtigruten.png?v=1778226194" alt="Hurtigruten">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/6_23e79594-b2e7-4b33-a564-b315df679d3f.png?v=1740592715" alt="P&O UK">
                    <img style='max-width: 80px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/seabourn.png?v=1776767160" alt="Seabourn">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/3_a91cb943-dc8c-4292-88c8-a61b6e078064.png?v=1740592715" alt="Cunard">
                    <img style='max-height: 35px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/river-cruises.png?v=1776767161" alt="River Cruises">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/holland-america-line.png?v=1776767161" alt="Holland America Line">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/marella-cruises.png?v=1776767160" alt="Marella">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/4_ceb086cf-faf4-4b37-bbae-5bbc7c19bf8a.png?v=1740592715" alt="P&O">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/2_f0c9738d-0c37-4f63-aebf-2325a97271d2.png?v=1740592715" alt="Hurtigruten expeditions">
                    <img class="m-light" src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/msc-logo.png?v=1758704905" alt="MSC">
                    <img style='max-width: 80px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/logo-hurtigruten.png?v=1778226194" alt="Hurtigruten">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/6_23e79594-b2e7-4b33-a564-b315df679d3f.png?v=1740592715" alt="P&O UK">
                    <img style='max-width: 80px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/seabourn.png?v=1776767160" alt="Seabourn">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/3_a91cb943-dc8c-4292-88c8-a61b6e078064.png?v=1740592715" alt="Cunard">
                    <img style='max-height: 35px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/river-cruises.png?v=1776767161" alt="River Cruises">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/holland-america-line.png?v=1776767161" alt="Holland America Line">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/marella-cruises.png?v=1776767160" alt="Marella">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/4_ceb086cf-faf4-4b37-bbae-5bbc7c19bf8a.png?v=1740592715" alt="P&O">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/2_f0c9738d-0c37-4f63-aebf-2325a97271d2.png?v=1740592715" alt="Hurtigruten expeditions">
                    <img class="m-light" src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/msc-logo.png?v=1758704905" alt="MSC">
                    <img style='max-width: 80px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/logo-hurtigruten.png?v=1778226194" alt="Hurtigruten">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/6_23e79594-b2e7-4b33-a564-b315df679d3f.png?v=1740592715" alt="P&O UK">
                    <img style='max-width: 80px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/seabourn.png?v=1776767160" alt="Seabourn">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/3_a91cb943-dc8c-4292-88c8-a61b6e078064.png?v=1740592715" alt="Cunard">
                    <img style='max-height: 35px;' src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/river-cruises.png?v=1776767161" alt="River Cruises">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/holland-america-line.png?v=1776767161" alt="Holland America Line">
                    <img src="https://cdn.shopify.com/s/files/1/0761/5804/2402/files/marella-cruises.png?v=1776767160" alt="Marella">
                </div>
            </div>
        </div>`;

        cartBody.appendChild(reviewsDiv);

        let currentIndex = 0;
        const reviewsContainer = document.querySelector(".reviews-container");
        const totalReviews = document.querySelectorAll(".review-card").length;
        const updateSlider = () => {
            reviewsContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
        };

        document.querySelector(".review-prev").addEventListener("click", () => {
            currentIndex = (currentIndex - 1 + totalReviews) % totalReviews;
            updateSlider();
        });

        document.querySelector(".review-next").addEventListener("click", () => {
            currentIndex = (currentIndex + 1) % totalReviews;
            updateSlider();
        });
    }

    function initPurchaseBlock() {
        const bottomModules = document.querySelector(".styles_CartPreview__bottomModules__");
        let purchaseBlock = document.createElement("div");
        const purchaseBlockDataJSON = localStorage.getItem('purchaseBlockData') || null;

        purchaseBlock.classList.add("purchase-block");

        purchaseBlock.innerHTML = `<style>
            .purchase-block {
                padding: 20px;
                display: none;
            }
            .purchase-block.show {
                display: block;
            }
            .purchase-block__wrapper {
                padding: 15px;
                display: flex;
                align-items: center;
                gap: 20px;
                background: #E4F0F9;
            }
            .purchase-block__main {
                display: flex;
                flex-direction: column;
                gap: 7px;
                align-items: center;
                flex-grow: 1;
            }
            .purchase-block__media {
                display: flex;
                min-width: 90px;
            }
            .purchase-block__img {
                width: 90px;
                height: 90px;
                vertical-align: top;
                object-fit: cover;
            }
            .purchase-block__title {
                font-size: 12px;
                font-weight: 600;
                text-align: center;
                line-height: 1;
                margin: 0;
                min-height: 22px;
            }
            .purchase-block__btn {
                font-weight: 700;
                font-size: 14px;
                line-height: 100%;
                width: 100%;
                padding: 11px 12px 10px 12px;
                border-radius: 38px;
                background: #fff;
                border: 2px solid #B7835A;
                text-align: center;
                text-decoration: none;
                color: #B7835A;
                transition: all 300ms;
            }

            .styles_CartPreview__bottomModules__:has(.purchase-block) #up-upsell-carousel {
                margin-top: -14px;
            }

            @media screen and (min-width: 768px) {
                .purchase-block__btn:hover {
                    color: #fff;
                    background: #B7835A;
                }
            }

            @media screen and (max-width: 600px) {
                .purchase-block__wrapper {
                    padding: 5px;
                }
                .purchase-block__img {
                    width: 80px;
                    height: 80px;
                }
                .purchase-block__media {
                    min-width: 80px;
                }
            }
        </style>
        <div class="purchase-block__wrapper">
            <div class='purchase-block__media'>
            <img src="//thecruisemaps.com/cdn/shop/files/Rectangle_158_90x90.png?v=1787268134" width="90" height="90" alt="Add another map to get 15% off" class="purchase-block__img">
            </div>
            <div class='purchase-block__main'>
            <h3 class='purchase-block__title'>Add another map to get 15% off</h3>
            <a class='purchase-block__btn' href="/products/cruise-map">Shop now</a>
            </div>
        </div>
        `;

        if (bottomModules) {
            bottomModules.prepend(purchaseBlock);
        }

        if (purchaseBlockDataJSON) {
            purchaseBlock.classList.add("show");
            const purchaseBlockData = JSON.parse(purchaseBlockDataJSON) || null;

            updatePurchaseBlock(purchaseBlockData.img, purchaseBlockData.title, purchaseBlockData.link);
        } else {
            const cart = upcartGetCart();
            const reversedItems = [...cart.items].reverse();

            if(reversedItems.length) {
                localStorage.setItem('previousUpcart', JSON.stringify(cart.items));
                localStorage.setItem('cartProduct', JSON.stringify(cart.items[0]));
                localStorage.setItem('cartProductHistory', JSON.stringify(reversedItems));
                let newCartQuantity = getNewCartQuantity(cart.items);

                checkRules(cart.items[0], cart.items, newCartQuantity)
            }
        }


        function getNewCartQuantity(items) {
            let newCartQuantity = 0;

            items.forEach(item => {
                newCartQuantity += item.quantity;
            });

            return newCartQuantity
        }

        function getTotalQuantityMap(items) {
            let quantity = items.filter(item => item.properties && item.properties['Ship Name']).reduce((sum, item) => sum + (item.quantity || 0), 0);
            return quantity
        }

        function addVariantToLink(link,title,handle) {
            let newLink = link;
            let options = title.split(' / ');

            if(handle.includes("satellite")){
                newLink = newLink + '-satellite';
            }

            let url = new URL(newLink, window.location.origin);

            let size = options[0].split(' - ')[options[0].split(' - ').length - 1].trim();
            let orientation = '';
            let frame = '';

            if(title.includes("Album")) {
                orientation = options[2].trim();
                frame = options[1].trim();
            } else {
                orientation = options[3].trim();
                frame = options[2].trim();
            }

            if(handle.includes("digital") || title.includes("Album")) {
                if(orientation) {
                    switch(orientation) {
                    case "Landscape":
                        url.searchParams.set('orientation', "landscape");
                        break;
                    case "Portrait":
                        url.searchParams.set('orientation', "portrait");
                        break;
                    default:
                        url.searchParams.set('orientation', `${orientation}`);
                        break;
                    }
                }

            } else {
                if(size) {
                    switch(size) {
                        case "45 x 60cm":
                            url.searchParams.set('size', "size2");
                            break;
                        case "Album":
                            url.searchParams.set('size', "sizeAlbum");
                            break;
                        case "21 x 29.7cm":
                            url.searchParams.set('size', "sizeAlbum");
                            break;
                        case "A4":
                            url.searchParams.set('size', "sizeAlbum");
                            break;
                        case "Album Size (A4)":
                            url.searchParams.set('size', "sizeAlbum");
                            break;
                        default:
                            url.searchParams.set('size', "size1");
                            break;
                    }
                }
            
                if(orientation) {
                    switch(orientation) {
                    case "Landscape":
                        url.searchParams.set('orientation', "landscape");
                        break;
                    case "Portrait":
                        url.searchParams.set('orientation', "portrait");
                        break;
                    default:
                        url.searchParams.set('orientation', `${orientation}`);
                        break;
                    }
                }
            
                if(frame) {
                    switch(frame) {
                    case "Classic black":
                        url.searchParams.set('frame', "black_frame");
                        break;
                    case "Natural wood":
                        url.searchParams.set('frame', "wood_frame");
                        break;
                    case "Crisp white":
                        url.searchParams.set('frame', "white_frame");
                        break;
                    case "Limited Edition Gold":
                        url.searchParams.set('frame', "limited_edition_gold");
                        break;
                    default:
                        url.searchParams.set('frame', `${frame}`);
                        break;
                    }
                }
            }
            
            
            return url.toString()

        }

        function updatePurchaseBlock(img,title,link) {
            const imgBlock = document.querySelector(".purchase-block__img");
            const titleBlock = document.querySelector(".purchase-block__title");
            const btnBlock = document.querySelector(".purchase-block__btn");

            if (imgBlock) {
                imgBlock.src = img;
                imgBlock.alt = title;
            }

            if (titleBlock) {
                titleBlock.textContent = title;
            }

            if (btnBlock) {
                btnBlock.href = link;
            }

            const purchaseBlockData = {
                img,
                title,
                link
            };

            localStorage.setItem('purchaseBlockData', JSON.stringify(purchaseBlockData));
            localStorage.setItem('view_switch_shipname', '');
            localStorage.setItem('view_switch_startport', '');
            localStorage.setItem('view_switch_endport', '');
            purchaseBlock.classList.add("show");
        }

        function chooseLink(item) {
            let handle = item.handle;
            let title = item.title;

            let link = '';
            
            if (handle.includes("album-map")) {
                link = cartDrawerSettings.bundle
            } else if (handle.includes('digital') && !handle.includes('digital-custom-river')) {
                link = cartDrawerSettings.digital
            } else if (handle.includes("digital-custom-river")) {
                link = cartDrawerSettings.digitalRiver
            } else if (handle.includes("custom-river")) {
                link = cartDrawerSettings.physicalRiver
            } else {
                link = cartDrawerSettings.physical
            }

            let linkVariant = addVariantToLink(link,title,handle);

            return linkVariant
        }

        function checkRules(item, items, newCartQuantity) {
            const totalQuantity = getTotalQuantityMap(items);

                if(totalQuantity && !item?.properties['Ship Name']) return

                if(item?.properties['Ship Name']) {
                    let url = chooseLink(item);
                    if( newCartQuantity > 1 && totalQuantity > 1) {
                        let title = item.title
                        let handle = item.handle

                        if (title.includes("A4") && !title.includes("Gift")) {
                            let linkVariant = addVariantToLink(cartDrawerSettings.bundle,title,handle);
                            const itemsWithA4 = items.filter(item => item.title.includes("A4") && !item.title.includes("Gift"));
                            const totalA4Quantity = itemsWithA4.reduce((sum, item) => {
                                return sum + item.quantity;
                            }, 0);
                            if(totalA4Quantity === 2) {
                                updatePurchaseBlock(cartDrawerSettings.secondAlbImg, cartDrawerSettings.secondAlbText, linkVariant); 
                            } else if(totalA4Quantity === 3) {
                                updatePurchaseBlock(cartDrawerSettings.thirdAlbImg, cartDrawerSettings.thirdAlbText, linkVariant); 
                            } else if(totalA4Quantity === 4) {
                                updatePurchaseBlock(cartDrawerSettings.fourthAlbImg, cartDrawerSettings.fourthAlbText, linkVariant); 
                            } else {
                                updatePurchaseBlock(cartDrawerSettings.elseMpImg, cartDrawerSettings.elseMpText, url);
                            }

                        } else {
                            updatePurchaseBlock(cartDrawerSettings.elseMpImg, cartDrawerSettings.elseMpText, url); 
                        }
                        
                    } else {
                        updatePurchaseBlock(cartDrawerSettings.firstMpImg, cartDrawerSettings.firstMpText, url); 
                    }
                } else {
                    updatePurchaseBlock(cartDrawerSettings.notMpImg, cartDrawerSettings.notMpText, cartDrawerSettings.shopAll);
                }
        
        }

        function isSameCartItem(a, b) {
            if (a.productId !== b.productId || a.title !== b.title) {
                return false;
            }
        
            if (a.properties && b.properties) {
                const aKeys = Object.keys(a.properties).filter(k => !k.startsWith('_'));
                const bKeys = Object.keys(b.properties).filter(k => !k.startsWith('_'));
        
                if (aKeys.length !== bKeys.length) return false;
        
                for (const key of aKeys) {
                    if (a.properties[key] !== b.properties[key]) {
                        return false;
                    }
                }
            }
        
            return true;
        }

        function checkingСhangesCart(items) {

            let cartProductJSON = localStorage.getItem('cartProduct');
            let cartProduct = cartProductJSON && cartProductJSON !== 'undefined' ? JSON.parse(cartProductJSON) : null;
            let cartProductHistoryJSON = localStorage.getItem('cartProductHistory');
            let cartProductHistory = cartProductHistoryJSON && cartProductHistoryJSON !== 'undefined' ? JSON.parse(cartProductHistoryJSON) : [];
            const previousCartJSON = localStorage.getItem('previousUpcart');
            const previousCart = previousCartJSON && previousCartJSON !== 'undefined' ? JSON.parse(previousCartJSON) : null;
            let newCartItems = items.length;
            let newCartQuantity = getNewCartQuantity(items);

            if(!newCartItems) {
                localStorage.setItem('previousUpcart', '');
                localStorage.setItem('cartProduct', '');
                localStorage.setItem('cartProductHistory', '');
                purchaseBlock.classList.remove("show");
                return
            }


            if(newCartQuantity > 1) {
                items.forEach((item) => {
                    const previousItem = previousCart?.find((prev) => isSameCartItem(prev, item));
                
                    if (previousItem) {
                        if (previousItem.quantity !== item.quantity) {
                            localStorage.setItem('cartProduct', JSON.stringify(item));
                            if(cartProduct && previousItem.quantity < item.quantity) {
                                cartProductHistory.push(cartProduct);
                                localStorage.setItem('cartProductHistory', JSON.stringify(cartProductHistory));
                                checkRules(item, items, newCartQuantity)
                            } else if(cartProduct && previousItem.quantity > item.quantity && item.title.includes("A4")) {
                                checkRules(item, items, newCartQuantity)
                            }
                        }
                    } else {
                        localStorage.setItem('cartProduct', JSON.stringify(item));
                        if(cartProduct) {
                            cartProductHistory.push(cartProduct);
                            localStorage.setItem('cartProductHistory', JSON.stringify(cartProductHistory));
                        }
                        checkRules(item, items, newCartQuantity)
                    }
                });
                
            } else {
                localStorage.setItem('cartProduct', JSON.stringify(items[0]));
                checkRules(items[0], items, 1)
            }

            localStorage.setItem('previousUpcart', JSON.stringify(items));

        }

        function getCart() {

            setTimeout(function() {
                const cart = upcartGetCart();
                console.log(localStorage);
                console.log(window);
                console.log('1111', cart)
                checkingСhangesCart(cart.items);
            },1000)
        }

        window.upcartSubscribeCartUpdated(function(cart) {
            getCart();
        });
        
        window.upcartSubscribeItemRemoved(function(item) {
            setTimeout(function() {
                const cart = upcartGetCart();
                const items = cart.items;
                let cartProductHistoryJSON = localStorage.getItem('cartProductHistory');
                let cartProductHistory = cartProductHistoryJSON ? JSON.parse(cartProductHistoryJSON) : [];
                let cartProductJSON = localStorage.getItem('cartProduct');
                let cartProduct = cartProductJSON ? JSON.parse(cartProductJSON) : null;

                const totalQuantity = getTotalQuantityMap(items);

                cartProductHistory.push(cartProduct);
                localStorage.setItem('cartProductHistory', JSON.stringify(cartProductHistory));

                let newCartQuantity = getNewCartQuantity(items);

                const filteredPreviousCart = cartProductHistory.filter(prevItem => {
                    if (prevItem.productId !== item.item.productId || prevItem.title !== item.item.title) {
                        return true;
                    }
                
                    const prevProps = Object.keys(prevItem.properties || {})
                        .filter(k => !k.startsWith('_'))
                        .reduce((obj, key) => {
                            obj[key] = prevItem.properties[key];
                            return obj;
                        }, {});
                
                    const itemProps = Object.keys(item.item.properties || {})
                        .filter(k => !k.startsWith('_'))
                        .reduce((obj, key) => {
                            obj[key] = item.item.properties[key];
                            return obj;
                        }, {});
                
                    if (Object.keys(prevProps).length !== Object.keys(itemProps).length) {
                        return true;
                    }
                
                    for (const key of Object.keys(prevProps)) {
                        if (prevProps[key] !== itemProps[key]) {
                            return true;
                        }
                    }
                
                    return false;
                });

                if (filteredPreviousCart.length > 0) {
                    let lastItem = null;

                    if(item.item?.properties['Ship Name'] && totalQuantity) {
                        for (let i = filteredPreviousCart.length - 1; i >= 0; i--) {
                            if (filteredPreviousCart[i]?.properties?.['Ship Name']) {
                                lastItem = filteredPreviousCart.splice(i, 1)[0];
                            break;
                            }
                        }
                    } else {
                        lastItem = filteredPreviousCart.pop();
                    }


                    if(!isSameCartItem(lastItem, item.item) || item.item?.properties['Ship Name']) {
                        checkRules(lastItem, items, newCartQuantity);
                        localStorage.setItem('cartProduct', JSON.stringify(lastItem));
                    } 
                    
                    localStorage.setItem('cartProductHistory', JSON.stringify(filteredPreviousCart));
                    localStorage.setItem('previousUpcart', JSON.stringify(items));
                }
            },1000)
        });

        getCart();
    }

    function startCountdown() {
        document.querySelectorAll('.card-promo-block .promo-time-end').forEach(function(el) {
            let endTime = parseInt(el.getAttribute('data-time'), 10) * 1000;
            let countdownEl = el.querySelector('.promo-countdown');

            function updateTimer() {
                let now = new Date().getTime();
                let distance = endTime - now;

                if (distance <= 0) {
                    countdownEl.textContent = "00:00:00";
                    clearInterval(timer);
                    return;
                }

                let hours = Math.floor(distance / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                countdownEl.textContent = 
                    String(hours).padStart(2, '0') + ":" + 
                    String(minutes).padStart(2, '0') + ":" + 
                    String(seconds).padStart(2, '0');
            }

            updateTimer();
            let timer = setInterval(updateTimer, 1000);
        });
    }

    function initPromoBlock() {
        

        const nowNew = Math.floor(Date.now() / 1000);
        const promoTrigger = 1764435600;
        const cartBody = document.querySelector(".upcart-cart-body");
        
        let promoBlock = document.createElement("div");
        promoBlock.classList.add("card-promo-block");

        let slidesHTML = "";

        if (nowNew < promoTrigger) {
            
                for (let i = 0; i < 4; i++) {
                    slidesHTML += `
                    <div class="card-promo-block__slide">
                        <div class="card-promo-block__text">Black Friday - our best ever deals - limited time only</div>
                    </div>
                    `;
                }
            
        } else {
            
                for (let i = 0; i < 4; i++) {
                    slidesHTML += `
                    <div class="card-promo-block__slide">
                        <div class="card-promo-block__text promo-time-end" data-time='1764694800'>
                        <span>Black Friday - extended our best ever deals - ends in&nbsp;</span>
                        
                            <span class="promo-countdown"></span>
                        
                        </div>
                    </div>
                    `;
                }
            
        }

        promoBlock.innerHTML = `<style>
            .card-promo-block__wrapper {
                background: #0A1218;
                padding: 0;
                margin: 0;
                overflow: hidden;
                height: 34px;
                position: sticky;
            }
            .card-promo-block__slider {
                display: flex;
                gap: 40px;
                animation: promo-scroll 60s linear infinite;
                white-space: nowrap;
                align-items: center;
                height: 34px;
                padding: 8px 24px;
                position: absolute;
                left: 0;
                top: 0;
            }
            .card-promo-block__slide {
                display: flex;
            }
            .card-promo-block__text {
                font-family: "TerminaTest Bold";
                font-weight: 700;
                font-size: 14px;
                line-height: 100%;
                text-align: center;
                text-transform: uppercase;
                color: #fff;
                display: flex;
                align-items: center;
            }
            .card-promo-block__text .promo-countdown {
                min-width: 120px;
                display: block;
                text-align: start;
            }

            @keyframes promo-scroll {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
            }
        </style>

        <div class='card-promo-block__wrapper'>
            <div class="card-promo-block__slider">
                ${slidesHTML}
            </div>
        </div>
        `;

        cartBody.prepend(promoBlock);
        startCountdown();
    }

    function initPromoCard() {
        

        

            const bottomModules = document.querySelector(".styles_CartPreview__bottomModules__");
            const emptyBlock = document.querySelector(".styles_CartPreview__empty__");
            let purchaseBlock = document.createElement("div");
            const purchaseBlockDataJSON = localStorage.getItem('purchaseBlockData') || null;

            purchaseBlock.classList.add("purchase-block");

            purchaseBlock.innerHTML = `<style>
                .styles_CartPreview__empty__ {
                    positionL relative
                }
                .styles_CartPreview__empty__>div {
                    width: 100%;
                }
                .styles_CartPreview__empty__ .purchase-block {
                    padding: 0;
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                }
                .purchase-block {
                    padding: 20px;
                    display: none;
                }
                .purchase-block.show {
                    display: block;
                }
                .purchase-block__wrapper {
                    padding: 15px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    background: #13222E;
                }
                .purchase-block__main {
                    display: flex;
                    flex-direction: column;
                    gap: 7px;
                    align-items: center;
                    flex-grow: 1;
                }
                .purchase-block__media {
                    display: flex;
                    min-width: 90px;
                }
                .purchase-block__img {
                    width: 90px;
                    height: 90px;
                    vertical-align: top;
                    object-fit: cover;
                }
                .styles_CartPreview__empty__ h3.purchase-block__title,
                .purchase-block__title {
                    font-size: 15px;
                    font-weight: 700;
                    text-align: center;
                    line-height: 120%;
                    margin: 0;
                    min-height: 36px;
                    color: #fff;
                }
                .purchase-block__btn {
                    font-family: "Sofia pro Medium", sans-serif;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 100%;
                    width: 100%;
                    padding: 11px 12px 10px 12px;
                    border-radius: 38px;
                    background: #fff;
                    border: 2px solid #B7835A;
                    text-align: center;
                    text-decoration: none;
                    color: #B7835A;
                    transition: all 300ms;
                }

                .styles_CartPreview__bottomModules__:has(.purchase-block) #up-upsell-carousel {
                    margin-top: -14px;
                }

                @media screen and (min-width: 768px) {
                    .purchase-block__btn:hover {
                        color: #fff;
                        background: #B7835A;
                    }
                }

                @media screen and (max-width: 600px) {
                    .purchase-block__wrapper {
                        padding: 5px;
                    }
                    .purchase-block__img {
                        width: 80px;
                        height: 80px;
                    }
                    .purchase-block__media {
                        min-width: 80px;
                    }
                    .styles_CartPreview__empty__ h3.purchase-block__title br,
                    .purchase-block__title br {
                        display: none;
                    }
                }
            </style>
            <div class="purchase-block__wrapper">
                <div class='purchase-block__media'>
                <img src="//thecruisemaps.com/cdn/shop/files/Group_1_90x90.png?v=1787291669" width="90" height="90" alt="BLACK FRIDAY 
OUR BIGGEST EVER DEALS" class="purchase-block__img">
                </div>
                <div class='purchase-block__main'>
                <h3 class='purchase-block__title'>BLACK FRIDAY <br />
OUR BIGGEST EVER DEALS</h3>
                <a class='purchase-block__btn' href="/collections/frontpage">Shop Black Friday Deals</a>
                </div>
            </div>
            `;

            if (bottomModules) {
                bottomModules.prepend(purchaseBlock);
            } else {
                const customMessage = emptyBlock.querySelector(".custom-cart-message");
                if (customMessage) {
                    customMessage.insertAdjacentElement("afterend", purchaseBlock);
                }
            }

            purchaseBlock.classList.add("show");

        
    }   

    function chooseCart() {
        const cartBody = document.querySelector(".upcart-cart-body");
        const emptyBlock = document.querySelector(".styles_CartPreview__empty__");

        if (cartBody) {

            const reviewsSection = document.querySelector(".reviews-section");

            if(!reviewsSection) {
                initReviewsAndTrusted();
            }const purchaseBlock = document.querySelector(".purchase-block");

                    if(!purchaseBlock) {
                        initPurchaseBlock();
                    }

                    window.upcartSubscribeCartOpened(() => {
                        const purchaseBlock = document.querySelector(".purchase-block");
                        if(!purchaseBlock) {
                            initPurchaseBlock();
                        }
                    });
                    
                    window.upcartSubscribeUpsellsRendered(() => {
                        const purchaseBlock = document.querySelector(".purchase-block");
                        if(!purchaseBlock) {
                            initPurchaseBlock();
                        }
                    });
            
            
        }

         if (emptyBlock) {
            

        }
    }


    window.upcartSubscribeCartOpened(() => {

        function checkCart() {
            const cartBody = document.querySelector(".upcart-cart-body");
            const emptyBlock = document.querySelector(".styles_CartPreview__empty__");
            if(emptyBlock || cartBody) {
                chooseCart();
            } else {
                setTimeout(function() {
                    checkCart();
                },200)
            }
        }

        checkCart();
    });});